import type { PageBlockType, PageBlockColumnKey } from '../../api/types'

export type ColKey = PageBlockColumnKey

export const COL_KEYS: ColKey[] = ['column1', 'column2', 'column3']

/** A single block placed inside an editorial-grid column on the canvas. */
export interface ColBlock {
  id: string
  type: PageBlockType
}

export type PickerMode =
  | { kind: 'add' }
  | { kind: 'assign'; slotId: string; colKey: ColKey; colLabel: string; target: 'layout' | 'page' }

export interface CanvasSlot {
  id: string
  type: PageBlockType
  order: number
  config: Record<string, string | number | boolean | null>
  /** Multi-block column assignments (page editor only). */
  columnBlocks?: Partial<Record<ColKey, ColBlock[]>>
}

// Column index → theme accent tokens. Swap accent-primary/secondary/tertiary in index.css to re-theme.
export const COL_COLORS = [
  { bg: 'bg-accent-primary-fill',   dot: 'bg-accent-primary-solid',   label: 'text-accent-primary-fg'   },
  { bg: 'bg-accent-secondary-fill', dot: 'bg-accent-secondary-solid', label: 'text-accent-secondary-fg' },
  { bg: 'bg-accent-tertiary-fill',  dot: 'bg-accent-tertiary-solid',  label: 'text-accent-tertiary-fg'  },
]
